export class FormSelectModel {
  constructor(public value: string, public name: string) {}
}
